<template>
    <div class="card">
        <div class="card-header">Money Order, Cashier's Check, or MoneyGram Instructions</div>
        <div class="card-body">
            <b-row>
                <b-col>
                    <ol class="ol-list">
                        <li>Email MDH at <a href="mailto:health.ba@state.mn.us">health.ba@state.mn.us</a> to alert the staff of your
                            intention. Please include the following in the email:
                            <ol type="I">
                                <li>
                                    Payment number on Money Order, Cashier's Check, or MoneyGram
                                </li>
                                <li>
                                    Name
                                </li>
                                <li>
                                    License number (if available)
                                </li>
                                <li>
                                    Type of license applied for (Full, Guest, Temporary)
                                </li>
                            </ol>
                        </li>
                        <li>
                            Make your payment payable to "State of Minnesota"
                        </li>
                        <li>
                            Include a note referencing your email address and the date you sent the email
                        </li>
                        <li>
                            Mail To:
                            <p>
                                HEALTH OCCUPATIONS PROGRAM<br/>
                                Body Art Licensing<br/>
                                P.O. Box 64882<br/>
                                St. Paul, Minnesota 55164-0882
                            </p>
                        </li>
                    </ol>
                    <p class="font-weight-bold">
                        Please be advised that not following these instructions will result in a delay in the processing of your application.
                    </p>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="float-right">
                    <b-button to="/home">Return to Dashboard</b-button>
                </b-col>
            </b-row>
        </div>
    </div>

</template>
<script>
    export default {
        created() {
            document.title = "Check Payment Instructions - Body Art"
        }
    }
</script>